import * as Styled from './styled';
import * as Types from './types';
import Text from '~components/dumbs/Text';
import { Color as TTextColor } from '~components/dumbs/Text/types';
import Check from '~components/svgs/Check';
import Lock from '~components/svgs/Lock';

const stepsIconMap = {
  INITIAL: <Lock />,
  CURRENT: '',
  CHECKED: <Check />,
};

const stepsColorMap = {
  INITIAL: 'neutral-weak',
  CURRENT: 'neutral',
  CHECKED: 'success-strong',
};

function Steps({ steps }: Types.Steps) {
  return (
    <Styled.Steps>
      {steps.map((step) => (
        <Styled.Step $variant={step.status} key={step.label}>
          <Styled.StepWrapper>
            <Styled.Bullet>{stepsIconMap[step.status]}</Styled.Bullet>
            <Text
              variant={step.status === 'CURRENT' ? 'h500' : 'sub500'}
              color={stepsColorMap[step.status] as TTextColor}
              as="span"
            >
              {step.label}
            </Text>
          </Styled.StepWrapper>
        </Styled.Step>
      ))}
    </Styled.Steps>
  );
}

export default Steps;
